import React from 'react';

import { CardView } from '@knocklabs/react';

import { BodyRow, CardImage as CardImageWrapper, InlineHelpLink } from '../styles';
import { GuideActions, GuideHelpLink } from './shared';
import { CardContent, ImageContent } from './types';
import { isValidHttpUrl, useVatixGuide } from './useVatixGuide';

const CardImage: React.FC<{
  content: CardContent;
  onImageClick: (e: React.MouseEvent, image: ImageContent) => void;
}> = ({ content, onImageClick }) => {
  if (!content.image?.url) {
    return null;
  }

  return (
    <CardImageWrapper
      href={isValidHttpUrl(content.image.action) ? content.image.action : undefined}
      target="_blank"
      rel="noreferrer"
    >
      <CardView.Img
        src={content.image.url}
        alt={content.image.alt}
        onClick={(e) => content.image && onImageClick(e, content.image)}
      />
    </CardImageWrapper>
  );
};

export const VatixCard: React.FC<{ guideKey?: string }> = ({ guideKey }) => {
  const { guide, step, colorMode, onDismiss, onButtonClick, onImageClick } = useVatixGuide<CardContent>(
    'card',
    guideKey
  );

  if (!guide || !step) {
    return null;
  }

  const content = step.content;
  const imageAboveCopy = content.layout === 'image_top';
  const actionsAboveImage = !imageAboveCopy && Boolean(content.image?.url);
  const image = <CardImage content={content} onImageClick={onImageClick} />;

  return (
    <CardView.Root data-knock-color-mode={colorMode}>
      {imageAboveCopy && image}
      <CardView.Content>
        <div className="knock-guide-card__header">
          <div className="knock-guide-card__headline">{content.headline}</div>
          {content.dismissible && <CardView.DismissButton onClick={onDismiss} />}
        </div>
        <CardView.Title title={content.title} />
        <BodyRow>
          <CardView.Body body={content.body} />
          <GuideHelpLink helpLink={content.help_link} as={InlineHelpLink} />
        </BodyRow>
      </CardView.Content>
      <GuideActions view={CardView} content={content} withDivider={actionsAboveImage} onButtonClick={onButtonClick} />
      {!imageAboveCopy && image}
    </CardView.Root>
  );
};
